<template>
  <div>
    <div class="alert alert-danger text-center pb-3" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="pb-3">
      <b-form-file ref="fileinput" v-model="file" required></b-form-file>
    </div>

    <button class="btn btn-lg btn-block btn-success" :disabled="!file" @click="uploadFile">Upload file</button>

    <loading :loading="loading"></loading>

  </div>
</template>

<script>
import uploadService from '../../services/uploadService'

export default {
  data() {
    return {
      file: null,
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    uploadFile() {
      this.loading = true

      let fd = new FormData()
      fd.append('file', this.file)

      uploadService.uploadCSV(fd)
        .then(() => {
          this.$refs.fileinput.reset()
          this.$emit('uploadSuccess')
        })
        .catch(errRes => {
          this.errMsg = errRes.error
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/forms/UploadFileForm.vue